import React, { useState, useEffect } from "react";
import CustomButton, {
  OutlineCustomButton,
} from "shared/components/inputButton";
import { formatDateToMMDDYYYY } from "utils/common";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const ArtWorkDocument = ({
  contractDetails,
  sign,
  setSign,
  onSignSubmit,
  handleClear,
  htmlContent,
  setHtmlContent,
  modules,
  formats,
}) => {
  const date = formatDateToMMDDYYYY(contractDetails?.payload?.agreementDate);
  const delivery = formatDateToMMDDYYYY(
    contractDetails?.payload?.details?.deliveryDate
  );

  useEffect(() => {
    if (contractDetails) {
      const content =
        contractDetails?.payload?.htmlContent ||
        `
        <h1 class="mb-5 text-center"><strong>${
          contractDetails?.payload?.agreementName || "____________"
        }</strong></h1>
        <p class="mb-3">This artwork agreement (the "Agreement"), is entered into and made effective as of <strong>${
          date || "____________"
        }</strong>.</p>
        <p class="mb-3">By and Between </p>
        <p class="mb-3">
          <strong>${
            contractDetails?.payload?.primaryArtist?.fullLegalName ||
            "____________"
          }</strong>, p/k/a <strong>${
          contractDetails?.payload?.primaryArtist?.name || "____________"
        }</strong> (the "Artist"), an individual or an entity with an address at <strong>${
          contractDetails?.payload?.primaryArtist?.address || "____________"
        }</strong>
        </p>
        <p class="mb-3">And</p>  
        <p class="mb-3">
          <strong>${
            contractDetails?.payload?.details?.artworkCreatorName ||
            "____________"
          }</strong>, (the "<strong>Artwork Creator</strong>"), an individual or an entity with an address at <strong>${
          contractDetails?.payload?.details?.artworkCreatorAddress ||
          "____________"
        }</strong>
        </p>
        <h3 class="mt-5 mb-3">1. SCOPE OF WORK</h3>
        <p class="mb-3">
          The Artwork Creator agrees to create original artwork ("Artwork") for the Artist's music release, which will be used for, but is not limited to album covers, promotional materials, and digital assets. The details of the Artwork to be created are as follows:
        </p>
        <ul>
          <li>Title of the music releases: <strong>${
            contractDetails?.payload?.details?.musicRelaseName || "____________"
          }</strong></li>
          <li>Description of the Artwork: <strong>${
            contractDetails?.payload?.details?.artWorkDescription ||
            "____________"
          }</strong></li>
        </ul>
        <h3 class="mt-5 mb-3">2. COMPENSATION </h3>
        <p class="mb-3">
          The Artist agrees to pay the Artwork Creator a total fee of <strong> ${
            contractDetails?.payload?.details?.artworkFee || "____________"
          } </strong> for the Artwork. Payment shall be made as follows:
        </p>
        <ul>
          <li><strong>${
            contractDetails?.payload?.details?.paymentStructure ||
            "____________"
          }</strong></li>
        </ul>
        <h3 class="mt-5 mb-3">3. DELIVERY </h3>
        <p class="mb-3">
          The Artwork Creator agrees to deliver the completed Artwork to the Artist by <strong>${
            delivery || "____________"
          }</strong>. The Artwork will be delivered in the following format(s): <strong>${
          contractDetails?.payload?.details?.deliveryFormat || "____________"
        }</strong>.
        </p>
        <h3 class="mt-5 mb-3">4. COPYRIGHT AND OWNERSHIP</h3>
        <p>Upon full payment, the Artist will own the rights to the Artwork. The Artwork Creator retains the right to display the Artwork in their portfolio and for self-promotion purposes.</p>
        <h3 class="mt-5 mb-3">5. Revisions</h3>
        <p>The Artist is entitled to <strong>${
          contractDetails?.payload?.details?.revisonRound || "____________"
        }</strong> rounds of revisions to the Artwork. Additional revisions beyond this limit will incur a fee of <strong>
        ${
          contractDetails?.payload?.details?.additionalCharges || "____________"
        }</strong> per revision.</p>
        <h3 class="mt-5 mb-3">6. REPRESENTATION AND WARRANTIES</h3>
        <p>The Artwork Creator warrants that the Artwork is original and does not infringe upon any third-party rights. The Artwork Creator shall indemnify the Artist against any claims arising from a breach of this warranty.<strong>${contractDetails?.payload?.details?.warrenties}</strong></p>
        <h3 class="mt-5 mb-3">7. TERMINATION</h3>
        <p>Either party may terminate this Agreement upon written notice if the other party breaches any material term of this Agreement and fails to cure the breach within <strong>${
          contractDetails?.payload?.details?.days || "____________"
        }</strong> days of receiving written notice of such breach.</p>
        <h3 class="mt-5 mb-3">8. GOVERNING LAW</h3>
        <p>This Agreement shall be governed by and construed in accordance with the laws of <strong>${
          contractDetails?.payload?.details?.law || "____________"
        }</strong>.</p>
        <h3 class="mt-5 mb-3">9. ENTIRE AGREEMENT </h3>
        <p>This Agreement constitutes the entire understanding between the parties and supersedes all prior discussions, agreements, or understandings of any kind.</p>
        <p class="mt-6 mb-3">IN WITNESS WHEREOF, </p>
        <p>the parties hereto have executed this Artwork Agreement as of the date first above written.</p>
        <p class="mt-7 mb-3">ACCEPTED AND AGREED TO BY:</p>
      `;

      setHtmlContent(content);
    }
  }, [contractDetails, date, delivery]);

  console.log("checking sing here ---- ", sign?.artist?.typedSignature)

  return (
    <div>
      <div className="bg-white shadow-1 p-5">
        <ReactQuill
          value={htmlContent}
          onChange={setHtmlContent}
          modules={modules}
          formats={formats}
          theme="snow"
          readOnly={false}
        />
        {(contractDetails?.payload?.status === "AWAITING_SIGNING" ||
          contractDetails?.payload?.status === "AWAITING_SHARE" ||
          contractDetails?.payload?.status === "SHARED_WITH_PARTY") && (
          <>
            {/* ---------- ARTIST ---------- */}
            <p className="mt-6 mb-3">Artist</p>
            <h3 className="mt-6 mb-3">
              <div style={{ position: "relative" }}>
                {/* Signature Display */}
                {contractDetails?.payload?.signatures?.find(
                  (sig) => sig.role === "artist"
                ) ? (
                  contractDetails.payload.signatures.find(
                    (sig) => sig.role === "artist"
                  ).signature ? (
                    <img
                      src={
                        contractDetails.payload.signatures.find(
                          (sig) => sig.role === "artist"
                        ).signature
                      }
                      style={{ width: "150px", height: "auto" }}
                      alt="Artist Signature"
                    />
                  ) : (
                    <div
                      style={{
                        minWidth: "150px",
                        borderBottom: "1px solid #000",
                        paddingBottom: "4px",
                        fontFamily: "cursive",
                      }}
                    >
                      {contractDetails.payload.signatures.find(
                        (sig) => sig.role === "artist"
                      ).typedSignature || " "}
                    </div>
                  )
                ) : sign?.artist?.signature ? (
                  <img
                    src={sign.artist.signature}
                    style={{ width: "150px", height: "auto" }}
                    alt="Artist Signature"
                  />
                ) : (
                  <div
                    style={{
                      minWidth: "150px",
                      borderBottom: "1px solid #000",
                      paddingBottom: "4px",
                      fontFamily: "cursive",
                    }}
                  >
                    {sign?.artist?.typedSignature || " "}
                  </div>
                )}

                {/* Sign Buttons (Only show during AWAITING_SIGNING & if not signed) */}
                {contractDetails?.payload?.status === "AWAITING_SIGNING" &&
                  !contractDetails?.payload?.signatures?.find(
                    (sig) => sig.role === "artist"
                  ) && (
                    <div
                      style={{ marginTop: "8px", display: "flex", gap: "8px" }}
                    >
                      {!sign?.artist?.signature &&
                      !sign?.artist?.typedSignature ? (
                        <CustomButton
                          label="Sign"
                          onClick={() => onSignSubmit("artist")}
                          disabled={false}
                          hideIfNoId={true}
                        />
                      ) : (
                        <>
                          <CustomButton
                            label="Resign"
                            onClick={() => onSignSubmit("artist")}
                            disabled={false}
                          />
                          <OutlineCustomButton
                            label="Clear"
                            onClick={() => {
                              if (typeof handleClear === "function") {
                                handleClear("artist");
                              } else {
                                setSign((prev) => ({
                                  ...prev,
                                  artist: { signature: "", typedSignature: "" },
                                }));
                              }
                            }}
                          />
                        </>
                      )}
                    </div>
                    
                  )}
                  {/* <p className="mb-3">By: </p>
                  <p className="mb-3">Date:</p> */}
              </div>
            </h3>

            {/* ---------- ARTWORK CREATOR ---------- */}
            <p className="mt-6 mb-3">Artwork Creator</p>
            <h3 className="mt-6 mb-3">
              <div style={{ position: "relative" }}>
                {/* Signature Display */}
                {contractDetails?.payload?.signatures?.find(
                  (sig) => sig.role === "artworkCreator"
                ) ? (
                  contractDetails.payload.signatures.find(
                    (sig) => sig.role === "artworkCreator"
                  ).signature ? (
                    <img
                      src={
                        contractDetails.payload.signatures.find(
                          (sig) => sig.role === "artworkCreator"
                        ).signature
                      }
                      style={{ width: "150px", height: "auto" }}
                      alt="Artwork Creator Signature"
                    />
                  ) : (
                    <div
                      style={{
                        minWidth: "150px",
                        borderBottom: "1px solid #000",
                        paddingBottom: "4px",
                        fontFamily: "cursive",
                      }}
                    >
                      {contractDetails.payload.signatures.find(
                        (sig) => sig.role === "artworkCreator"
                      ).typedSignature || " "}
                    </div>
                  )
                ) : sign?.artworkCreator?.signature ? (
                  <img
                    src={sign.artworkCreator.signature}
                    style={{ width: "150px", height: "auto" }}
                    alt="Artwork Creator Signature"
                  />
                ) : (
                  <div
                    style={{
                      minWidth: "150px",
                      borderBottom: "1px solid #000",
                      paddingBottom: "4px",
                      fontFamily: "cursive",
                    }}
                  >
                    {sign?.artworkCreator?.typedSignature || " "}
                  </div>
                )}

                {/* Sign Buttons (Only show during AWAITING_SIGNING & if not signed) */}
                {contractDetails?.payload?.status === "AWAITING_SIGNING" &&
                  !contractDetails?.payload?.signatures?.find(
                    (sig) => sig.role === "artworkCreator"
                  ) && (
                    <div
                      style={{ marginTop: "8px", display: "flex", gap: "8px" }}
                    >
                      {!sign?.artworkCreator?.signature &&
                      !sign?.artworkCreator?.typedSignature ? (
                        <CustomButton
                          label="Sign"
                          onClick={() => onSignSubmit("artworkCreator")}
                          disabled={false}
                          hideIfNoId={true}
                        />
                      ) : (
                        <>
                          <CustomButton
                            label="Resign"
                            onClick={() => onSignSubmit("artworkCreator")}
                            disabled={false}
                          />
                          <OutlineCustomButton
                            label="Clear"
                            onClick={() => {
                              if (typeof handleClear === "function") {
                                handleClear("artworkCreator");
                              } else {
                                setSign((prev) => ({
                                  ...prev,
                                  artworkCreator: {
                                    signature: "",
                                    typedSignature: "",
                                  },
                                }));
                              }
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
              </div>
            </h3>
          </>
        )}
      </div>
    </div>
  );
};

export default ArtWorkDocument;
